import List from '../components/list/List'
import Filter from '../components/list/Filter'
import { Link } from 'react-router-dom'
import './ListView.css'

function ListView(props) {
    return (
        <>
            <Filter
                chosenMonth={props.chosenMonth} 
                setChosenMonth={props.setChosenMonth}
            />
            <List 
                data={props.data}
                chosenMonth={props.chosenMonth}
                showEuropean={props.showEuropean}
                filterCategory={props.filterCategory}
            />
            <div className="footer">
                <Link to="/om">Om Kolla Frukten</Link>
            </div>
        </>
    )
}

export default ListView